import { useTranslation } from 'react-i18next';

import { VEHICLE_FEATURES } from '../constants';

export const useVehicleFeatureOptions = () => {
    const { t } = useTranslation('common');

    return VEHICLE_FEATURES.map((key) => ({
        value: Number(key),
        label: t(`entities.vehicle.feature.${key}`),
    }));
};
